import {
  useGetParentViewEnrollmentTimeline,
  useGetParentViewUniversitiesApplyingTo,
} from '@actions';
import EnrollmentTimeline from '@components/EnrollmentTimeline/EnrollmentTimeline';
import { useParams } from 'react-router';

const ParentPageTimeline = () => {
  const { studentId } = useParams<{ studentId: string }>();
  const token = localStorage.getItem('parentToken');

  const { data: timelineData, isLoading: isTimelineLoading } = useGetParentViewEnrollmentTimeline({
    userId: studentId,
    token: token ?? '',
  });

  const { data: universitiesData } = useGetParentViewUniversitiesApplyingTo({
    userId: studentId,
    token: token ?? '',
  });

  return (
    <EnrollmentTimeline
      timelineData={timelineData}
      universitiesData={universitiesData}
      isLoading={isTimelineLoading}
    />
  );
};

export default ParentPageTimeline;
